import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import "./calendar.css";
import {
  Card,
  CardBody,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Col,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import timeGridPlugin from "@fullcalendar/timegrid";
import Select from "react-select";

import * as Yup from "yup";
import { useFormik } from "formik";

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import BootstrapTheme from "@fullcalendar/bootstrap";
import Flatpickr from "react-flatpickr";

//redux
import { useSelector, useDispatch } from "react-redux";

import {
  getEvents as onGetEvents,
  getCategories as onGetCategories,
  addNewEvent as onAddNewEvent,
  deleteEvent as onDeleteEvent,
  updateEvent as onUpdateEvent,
  resetCalendar,
} from "../../slices/thunks";
import { createSelector } from "reselect";
import DeleteModal from "../../Components/Common/DeleteModal";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import avatar1 from "../../../src/assets/images/users/avatar-1.jpg";
import AppointmentService from "../../services/KangarooServices/AppointmentService";
import toast from "react-hot-toast";
import { eventData, events } from "./events";
import AgentService from "../../services/KangarooServices/AgentService";
import AppointmentDetail from "./Component/AppointmentDetail";

const Calender = () => {
  const dispatch = useDispatch();
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedDay, setSelectedDay] = useState(0);
  const [isEdit, setIsEdit] = useState(false);
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const toggleDetail = (item) => {
    setSelectedEvent(item);
    setIsDetailOpen(!isDetailOpen);
  };
  const [event, setEvent] = useState({});
  const [events, setEvents] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [isRight, setIsRight] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isHide, setIsHide] = useState(false);
  const [loading, setLoading] = useState(false);
  const calendarRef = useRef(null);
  const [agentData, setAgentData] = useState([]);
  const selectLayoutState = (state) => state.Calendar;
  const calendarDataProperties = createSelector(selectLayoutState, (state) => ({
    events: state.events,
  }));
  const [selectedAgents, setSelectedAgents] = useState([]); // array for multi-select
  const { isEventUpdated } = useSelector(calendarDataProperties);

  useEffect(() => {
    dispatch(onGetEvents());
    dispatch(onGetCategories());
  }, [dispatch]);

  useEffect(() => {
    if (isEventUpdated) {
      setIsEdit(false);
      setEvent({});
      setTimeout(() => {
        dispatch(resetCalendar("isEventUpdated", false));
      }, 500);
    }
  }, [dispatch, isEventUpdated]);

  const toggle = () => {
    if (modal) {
      setModal(false);
      setEvent(null);
      setIsEdit(false);
    } else {
      setModal(true);
    }
  };
  const fetchAgentData = async () => {
    try {
      setLoading(true);
      const result = await AgentService.getList();
      setAgentData(result);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAgentData();
  }, []);
  const fetchEvent = async (month, year, agentIds) => {
    try {
      console.log("Fetching events for month:", month, "year:", year);
      const response = await AppointmentService.getList({
        month,
        year,
        agentIds,
      });
      console.log("API Response:", response);

      if (!Array.isArray(response)) {
        console.error("Response is not an array:", response);
        return;
      }

      const events = response.flatMap((day) => {
        const dateStr = day.date.split("T")[0];

        return day.slots.flatMap((slot) => {
          const start = new Date(`${dateStr}T${slot.startTime}`);
          const end = new Date(`${dateStr}T${slot.endTime}`);

          if (!slot.agents || slot.agents.length === 0) {
            // If no agents, create a single empty slot event
            return [
              {
                id: `${dateStr}-${slot.startTime}-noagent`,
                title: "",
                start,
                end,
                allDay: false,
                className: "bg-transparent text-dark",
                extendedProps: {
                  agents: [],
                  start_time: slot.startTime,
                  end_time: slot.endTime,
                  icon: "bx bx-user",
                },
                display: "auto",
                textColor: "#fff",
              },
            ];
          }

          // Create one event per agent
          return slot.agents.map((agent) => {
            const titleParts = [];
            if (agent.agentName) titleParts.push(agent.agentName);
            if (agent.customerName)
              titleParts.push(`(${agent.customerName.trim()})`);

            return {
              id: `${dateStr}-${slot.startTime}-${agent.id}`, // unique per agent
              title: titleParts.join(" "),
              start,
              end,
              allDay: false,
              className: "bg-primary text-white",
              extendedProps: {
                fullName: titleParts.join(" "),
                agents: [agent],
                start_time: slot.startTime,
                end_time: slot.endTime,
                icon: "bx bx-user",
              },
              display: "auto",
              textColor: "#fff",
            };
          });
        });
      });

      console.log("Processed events:", events);
      console.log("Total events:", events.length);

      if (events.length === 0) {
        console.warn("No events were processed from the API response");
      }

      setEvents(events);
    } catch (error) {
      console.error("Error fetching events:", error);
      toast.error("Failed to fetch events");
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) {
        setIsHide(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;

    setSelectedYear({
      label: year.toString(),
      value: year,
    });

    setSelectedMonth(monthOptions.find((m) => m.value === month));
  }, []);

  useEffect(() => {
    if (selectedMonth && selectedYear) {
      fetchEvent(
        selectedMonth.value,
        selectedYear.value,
        selectedAgents.map((a) => a.value) // array of agent IDs
      );
    }
  }, [selectedMonth, selectedYear, selectedAgents]);

  let clickTimeout = null;

  const handleDateClick = (arg) => {
    if (clickTimeout) {
      clearTimeout(clickTimeout);
      clickTimeout = null;

      const date = arg.date;
      const day = date.getDate();
      const month = date.getMonth();
      const year = date.getFullYear();

      const currentDate = new Date();
      const currentHour = currentDate.getHours();
      const currentMin = currentDate.getMinutes();
      const currentSec = currentDate.getSeconds();

      const modifiedDate = new Date(
        year,
        month,
        day,
        currentHour,
        currentMin,
        currentSec
      );
      const modifiedData = { ...arg, date: modifiedDate };

      setSelectedDay(modifiedData);
      toggle();
    } else {
      clickTimeout = setTimeout(() => {
        clickTimeout = null;
      }, 200);
    }
  };

  const str_dt = function formatDate(date) {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const d = new Date(date);
    const month = monthNames[d.getMonth()];
    const day = d.getDate();
    const year = d.getFullYear();
    return [day + " " + month, year].join(",");
  };

  const date_r = function formatDate(date) {
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const year = d.getFullYear();
    return [year, month, day].join("-");
  };

  const handleEventClick = (arg) => {
    const event = arg.event;

    // Standard event dates
    const st_date = event.start;
    const ed_date = event.end;

    // Your custom formatted date function
    const r_date = str_dt(st_date);

    // Access extendedProps
    const extendedProps = event.extendedProps;

    console.log("Extended Props:", extendedProps);

    // Example: accessing a specific property
    // const customValue = extendedProps.someProperty;

    toggleDetail(extendedProps);
  };

  const handleDeleteEvent = () => {
    dispatch(onDeleteEvent(event.id));
    setDeleteModal(false);
    toggle();
  };

  const toggleHide = () => setIsHide((prev) => !prev);

  const currentYear = new Date().getFullYear();

  const yearOptions = Array.from({ length: 10 }, (_, i) => {
    const year = currentYear - i;
    return { label: year.toString(), value: year };
  });

  const monthOptions = [
    { label: "January", value: 1 },
    { label: "February", value: 2 },
    { label: "March", value: 3 },
    { label: "April", value: 4 },
    { label: "May", value: 5 },
    { label: "June", value: 6 },
    { label: "July", value: 7 },
    { label: "August", value: 8 },
    { label: "September", value: 9 },
    { label: "October", value: 10 },
    { label: "November", value: 11 },
    { label: "December", value: 12 },
  ];

  const agentOptions = agentData.map((group) => ({
    label: group.name,
    value: group.id,
  }));
  const handleAgentChange = (selectedOptions) => {
    setSelectedAgents(selectedOptions || []); // ensure it's always an array
  };
  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteEvent}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Calendar" pageTitle="Appointment">
            <button
              onClick={toggleHide}
              className="d-block d-md-none btn-sm btn"
              style={{ fontSize: "12px" }}
            >
              {isHide ? (
                <i className="ri-eye-line"></i>
              ) : (
                <i className="ri-eye-close-line"></i>
              )}
            </button>
          </BreadCrumb>

          <div>
            <Row className="align-items-end mb-3">
              <Col lg={4} md={4} xs={6}>
                <Label className="form-label">Year</Label>
                <Select
                  options={yearOptions}
                  value={selectedYear}
                  onChange={setSelectedYear}
                  placeholder="Select Year"
                  isClearable
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                />
              </Col>

              <Col lg={4} md={4} xs={6}>
                <Label className="form-label">Month</Label>
                <Select
                  options={monthOptions}
                  value={selectedMonth}
                  onChange={setSelectedMonth}
                  placeholder="Select Month"
                  isClearable
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                />
              </Col>
              <Col lg={4} md={4} xs={6}>
                <Label className="form-label">Agent</Label>
                <Select
                  options={agentOptions}
                  value={selectedAgents} // array of selected agents
                  onChange={handleAgentChange}
                  placeholder="Select Agent(s)"
                  isClearable
                  isMulti // allows multiple selection
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                />
              </Col>
            </Row>

            <div>
              <Card className="card-h-100">
                <CardBody>
                  <div ref={calendarRef}>
                    <FullCalendar
                      plugins={[
                        BootstrapTheme,
                        dayGridPlugin,
                        interactionPlugin,
                        listPlugin,
                        timeGridPlugin,
                      ]}
                      initialView={
                        window.matchMedia("(max-width: 468px)").matches
                          ? "dayGridWeek"
                          : "dayGridMonth"
                      }
                      firstDay={1}
                      views={{
                        dayGridWeek: {
                          dayHeaderFormat: {
                            weekday: "short",
                            day: "2-digit",
                            month: "2-digit",
                          },
                        },
                        timeGridWeek: {
                          firstDay: 1,
                          slotDuration: "00:30:00",
                          slotMinTime: "06:00:00",
                          slotMaxTime: "20:00:00",
                          allDaySlot: false,
                          slotLabelFormat: {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: false,
                          },
                        },
                      }}
                      buttonText={{
                        today: "Today",
                        month: "Month",
                        week: "Week",
                        day: "Day",
                        listWeek: "List",
                        timeGridWeek: "Time Grid",
                      }}
                      locale="en-GB"
                      slotDuration="00:15:00"
                      handleWindowResize={true}
                      themeSystem="bootstrap"
                      headerToolbar={{
                        left: "prev,next today",
                        center: "title",
                        right:
                          "dayGridMonth,dayGridWeek,dayGridDay,listWeek,timeGridWeek",
                      }}
                      events={events}
                      droppable={true}
                      selectable={true}
                      dateClick={handleDateClick}
                      eventClick={handleEventClick}
                      eventDidMount={(info) => {
                        console.log("🚀 Event mounted:", info.event.title);
                        console.log(
                          "Event extended props:",
                          info.event.extendedProps
                        );
                      }}
                      viewDidMount={(viewInfo) => {
                        console.log("View mounted:", viewInfo.view.type);
                        localStorage.setItem(
                          "lastCalendarView",
                          viewInfo.view.type
                        );
                      }}
                      height="auto"
                      contentHeight="auto"
                      eventContent={(arg) => {
                        // Render agent names with line breaks
                        const agents = arg.event.extendedProps.agents || [];
                        if (agents.length === 0) {
                          return { html: arg.event.title }; // fallback to normal title
                        }
                        const agentLines = agents
                          .map((agent) => {
                            const parts = [];
                            if (agent.customerName)
                              parts.push(`${agent.customerName.trim()}`);
                            if (agent.agentName)
                              parts.push(`(${agent.agentName})`);

                            return parts.join(" ");
                          })
                          .join("<br>"); // separate each agent on new line

                        return { html: agentLines };
                      }}
                    />
                  </div>
                </CardBody>
              </Card>
            </div>
          </div>
        </Container>
        <AppointmentDetail
          isOpen={isDetailOpen}
          toggle={toggleDetail}
          selectedEvent={selectedEvent}
        />
      </div>
    </React.Fragment>
  );
};

Calender.propTypes = {
  events: PropTypes.any,
  categories: PropTypes.array,
  className: PropTypes.string,
  onGetEvents: PropTypes.func,
  onAddNewEvent: PropTypes.func,
  onUpdateEvent: PropTypes.func,
  onDeleteEvent: PropTypes.func,
  onGetCategories: PropTypes.func,
};

export default Calender;
